module.exports = __webpack_public_path__ + "media/navi/lock_door_joiner-4b0f5af7.png";